module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright © 2021 by Amy Gentry")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Names: Gentry, Amy, author.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Title: Bad habits / Amy Gentry.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Description: Boston : Mariner Books, Houghton Mifflin Harcourt, 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2020034157 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2020034158 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358408574 (trade paperback) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358126546 (hardcover) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358439974 | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358440871 | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358125051 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCSH")]), _vm._v(": Psychological fiction. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GSAFD")]), _vm._v(": Suspense fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC PS")]), _vm._v("3607."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("567 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B")]), _vm._v("33 2021 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC PS")]), _vm._v("3607."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("567 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 813/.6—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("LC record available at https://lccn.loc.gov/2020034157")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("LC ebook record available at https://lccn.loc.gov/2020034158")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Cover design by Christopher Moisan")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover photographs: Shutterstock and © Ildiko Neer/Trevillion Images")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Author photograph © Matt Valentine")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("v1.0121")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0